import { render, staticRenderFns } from "./PasswordRequirements.vue?vue&type=template&id=6ae23d2a&scoped=true&lang=pug"
import script from "./PasswordRequirements.vue?vue&type=script&lang=ts"
export * from "./PasswordRequirements.vue?vue&type=script&lang=ts"
import style0 from "./PasswordRequirements.vue?vue&type=style&index=0&id=6ae23d2a&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ae23d2a",
  null
  
)

export default component.exports